import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Lafarge Orders';

  constructor(private translateService: TranslateService) { }

  ngOnInit() {
    this.translateService.addLangs(['en', 'es', 'fr']);
    this.translateService.setDefaultLang('en');
    const browserLang = this.translateService.getBrowserLang();
    this.translateService.use(browserLang.match(/en|fr|es/) ? browserLang : 'en');
  }

}
